export const BOOKING_STEPS = {
    EXTRAS: 'extras',
    DETAILS: 'details',
    PAYMENT: 'payment',
    PAYMENT_ACTION: 'payment-action',
    CONFIRMATION: 'confirmation'
};
